
import { User, UserRole } from "@/types";
import { v4 as uuidv4 } from "uuid";

// Chave para armazenar usuários no localStorage
const USERS_KEY = "sunjob_users";

// Funções auxiliares para gerenciar usuários
export const getUsers = (): User[] => {
  const data = localStorage.getItem(USERS_KEY);
  return data ? JSON.parse(data) : [];
};

export const saveUsers = (users: User[]): void => {
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
};

export const initializeAdmin = (): void => {
  const users = getUsers();
  // Verificar se já existe o usuário admin com o email projetos@sunjob.tech
  const existingAdmin = users.find(u => u.email === "projetos@sunjob.tech");
  
  if (!existingAdmin) {
    // Se não existir, criar o admin
    const adminUser = {
      id: uuidv4(),
      nome: "Administrador",
      email: "projetos@sunjob.tech",
      role: UserRole.ADMIN,
      senha: "Sasa@1212" // Esse campo será removido ao salvar no localStorage
    };
    
    // Salvar admin com senha codificada (em uma app real usaríamos hash)
    const usersToSave = [
      {
        id: adminUser.id,
        nome: adminUser.nome,
        email: adminUser.email,
        role: adminUser.role
      }
    ];
    
    saveUsers(usersToSave);
    localStorage.setItem("user_" + adminUser.id, adminUser.senha);
  } else if (existingAdmin.role !== UserRole.ADMIN) {
    // Se existir mas não for admin, atualizar para admin
    existingAdmin.role = UserRole.ADMIN;
    saveUsers(users);
  }
};

export const findUserByEmail = (email: string): User | undefined => {
  const users = getUsers();
  return users.find(u => u.email.toLowerCase() === email.toLowerCase());
};

export const storeUserPassword = (userId: string, password: string): void => {
  localStorage.setItem("user_" + userId, password);
};

export const getUserPassword = (userId: string): string | null => {
  return localStorage.getItem("user_" + userId);
};

export const removeUserPassword = (userId: string): void => {
  localStorage.removeItem("user_" + userId);
};

export const storeUserSession = (user: User): void => {
  // Remover campo senha antes de salvar no localStorage
  const { senha, ...userWithoutPassword } = user;
  localStorage.setItem("user", JSON.stringify(userWithoutPassword));
};

export const getUserSession = (): User | null => {
  const storedUser = localStorage.getItem("user");
  return storedUser ? JSON.parse(storedUser) : null;
};

export const clearUserSession = (): void => {
  localStorage.removeItem("user");
};
